import { useContext, useEffect, useMemo, useRef, useState } from "react";
import ContentCover from "./components/ContentCover";
import { useLocation, Routes, Route, Link } from "react-router-dom";
import Svg from "./components/svgs/Svg";
import Logo from "./components/Logo";
import { ShareContext } from "./contexts/ShareContext";
import { Controller, useForm } from "react-hook-form";
import {
  calculateAge,
  checkFullnameIsValid,
  checkLocaleIsEnglishOrThai,
  formatDateTime,
  formatDateTime_ddmmyyyy_to_yyyymmdd_v1,
  formatTimeToDateTimeV1,
  getHashOfDictionary,
  onGenerateReplyToken,
  onGenerateULID1,
  readDeviceType,
  readIpAddresses,
} from "./scripts/utils";
import SignaturePad from "./components/SignaturePad";
import {
  checkCompanyExist,
  checkTourAndBoatAndDateAvailable,
  checkUpdateTranslation,
  deToken,
  login,
  onOcrPassport,
  readCountryList,
  readGenderOption,
  readNationalityList,
  readPortAndTourByIdProject,
  readTourAndBoatDetail,
  submitPassenger,
  translationJson,
} from "./scripts/apis";
import Dev from "./Dev";
import Loading from "./components/Loading";
import { CaptureWrapper, useCaptureImage } from "./hooks/useCaptureImage";
import { useAlertModal } from "./hooks/useAlertModal";
import ExternalRedirect from "./components/ExternalRedirect";
import dictionary from "./constants/dictionary.json";
import CustomDatePicker from "./components/CustomDatePicker";
import dayjs from "dayjs";
import CustomInputText from "./components/CustomInputText";
import CustomSelect from "./components/CustomSelect";

export default function Root() {
  const [msg, setMsg] = useState(null);

  const { alert, AlertModal } = useAlertModal({ msg });

  const [dateTime, setDateTime] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [section, setSection] = useState("afterScanQrCode");
  const [method, setMethod] = useState(""); // photo/form
  const [countryOption, setCountryOption] = useState([]);
  const [nationalityOption, setNationalityOption] = useState([]);
  const [genderOption, setGenderOption] = useState([]);
  const [tourAndBoatDetail, setTourAndBoatDetail] = useState();
  const [isUseOcr, setIsUseOcr] = useState(false);

  const [fetchPortData, setFetchPortData] = useState([]);

  const [transactionId, setTransactionId] = useState();
  const [ipv4, setIpv4] = useState();
  const [ipv6, setIpv6] = useState();
  const [deviceType, setDeviceType] = useState();

  const [isSign, setIsSign] = useState(false);
  const [token, setToken] = useState();

  const [replyToken, setReplyToken] = useState("");

  const [selectedPort, setSelectedPort] = useState(null);
  const [selectedBoat, setSelectedBoat] = useState(null);
  const [filteredPortData, setFilteredPortData] = useState([]);

  const hookForm = useForm();
  const { register, handleSubmit, setValue, getValues, reset, watch } =
    hookForm;

  const signPadRef = useRef();

  const dataPortList = fetchPortData?.data || [];

  const autoFilterBoatInPortByActiveBoatList = () => {
    const now = new Date();
    const tempfetchPortData = JSON.parse(JSON.stringify(fetchPortData));
    const filteredData = (tempfetchPortData?.data || []).map((el) => {
      const temp = el;
      const tempActiveBoatList = el.activeBoatList.filter((el2) => {
        const { start_date, end_date, start_time, end_time } =
          el2.active_datetime;
        // เช็คว่ายังไม่เกินวัน
        const deadlineDate = new Date(`${end_date} ${end_time}`);
        deadlineDate.setHours(deadlineDate.getHours() + 1); // เพิ่มเวลาอีก 1 ชั่วโมง
        const isInDateRange = now <= deadlineDate;
        return isInDateRange;
      });
      temp.activeBoatList = tempActiveBoatList;
      temp.numOfBoat = tempActiveBoatList.length;
      return temp;
    });
    setFetchPortData({ ...fetchPortData, data: filteredData });

    // ตรวจสอบว่า port ที่เลือกมีอยู่ใน filteredData หรือไม่ ถ้าไม่มีให้ล้าง selectedPort
    const selectPort = filteredData.find(
      (el) => el.id_port === selectedPort?.id_port
    );
    if (selectPort?.numOfBoat === 0) {
      gotoPortPage();
      return;
    }

    const selectBoat = (
      filteredData.find((el) => el.id_port === selectedPort?.id_port)
        ?.activeBoatList || []
    ).find((el) => el.id_boat === selectedBoat?.id_boat);
    let deadline = `${selectBoat?.active_datetime?.end_date} ${selectBoat?.active_datetime?.end_time}`;
    // 1 hr added
    deadline = dayjs().isAfter(dayjs(deadline).add(1, "hour"));
    if (deadline) {
      gotoBoatPage();
      return;
    }
  };

  const handleClear = () => {
    signPadRef.current?.clearCanvas();
    setIsSign(false);
  };

  const { ref: captureImageRef, getBase64 } = useCaptureImage();

  const onSetToken = (value) => {
    setToken(value);
  };

  const getCurrentLanguage = () =>
    navigator.language.split("-")[0].toLowerCase();

  const onSetCountryOption = async () => {
    const temp = await readCountryList();
    const isThaiLanguage = getCurrentLanguage() === "th";
    const option = temp.data.map((el) => ({
      value: el.id_country,
      label: isThaiLanguage ? el.label_th : el.label_en,
      alpha3: el.alpha3,
    }));
    setCountryOption(option);
  };

  const onSetNationalityOption = async () => {
    const temp = await readNationalityList();
    const isThaiLanguage = getCurrentLanguage() === "th";
    const option = temp.data.map((el) => ({
      value: el.id_nationality,
      label: isThaiLanguage ? el.label_th : el.label_en,
      label_en: el.label_en,
      label_th: el.label_th,
    }));
    setNationalityOption(option);
  };

  const onSetGenderOption = async () => {
    const temp = await readGenderOption();
    setGenderOption(temp.data);
  };

  const onSetupLang = async () => {
    // แสดงผลภาษาอังกฤษเท่านั้น
    setMsg(dictionary);
    return;

    const target = getCurrentLanguage();

    if (target === "en") {
      setMsg(dictionary);
      return;
    }

    const hash = getHashOfDictionary(dictionary);
    const checkUpdate = await checkUpdateTranslation({ hash, target });

    if (checkUpdate?.command === "next") {
      const translationData = await translationJson(
        { dictionaryString: JSON.stringify(dictionary), target, hash },
        token
      );
      if (translationData.status === "success") {
        setMsg(translationData.data);
      }
    } else if (checkUpdate.status === "success") {
      setMsg(checkUpdate.data);
    }
  };

  const onInitMain = async (tokenString, setNotFound) => {
    try {
      onSetToken(tokenString);
      onSetReplyToken();
      const result = await deToken(tokenString);

      if (result.status === "error") {
        localStorage.clear();
        window.location.replace("/");
        return;
      }

      const { id_tour_and_date, id_boat, id_tour, id_account } = result.data;

      await onSetupLang();

      await Promise.all([
        onAfterScanQrCode({ id_tour_and_date, id_boat }),
        onSetCountryOption(),
        onSetNationalityOption(),
        onSetTourAndBoatDetail({ id_tour, id_boat }),
        onSetTransactionIdAndTimestamp(),
        onSetGenderOption(),
      ]);
    } catch (error) {
      console.error("Error initializing main:", error);
      setNotFound(true);
    } finally {
      onSetIsLoading(false);
    }
  };

  const onInitMainForSelectPortBoat = async (id_project, setNotFound) => {
    try {
      await onSetupLang();
      const [portResult] = await Promise.all([
        loadPortData(id_project),
        onSetCountryOption(),
        onSetNationalityOption(),
        onSetTransactionIdAndTimestamp(),
        onSetGenderOption(),
      ]);
      if (portResult.status !== "success") {
        setNotFound(true);
      }
      setSection("select-port-boat");
    } catch (error) {
      console.error("Error initializing main for select port/boat:", error);
      setNotFound(true);
    } finally {
      onSetIsLoading(false);
    }
  };

  const onSetIsLoading = (value) => setIsLoading(value);

  const onSetTransactionIdAndTimestamp = async () => {
    const { ipv4: tempIpv4, ipv6: tempIpv6 } = await readIpAddresses();
    const ulid = onGenerateULID1();

    setIpv4(tempIpv4);
    setIpv6(tempIpv6);
    setTransactionId(`${tempIpv4}-${ulid}`);
    setDeviceType(readDeviceType());
  };

  const onAfterScanQrCode = async ({ id_tour_and_date, id_boat }) => {
    const result = await checkTourAndBoatAndDateAvailable({
      id_tour_and_date,
      id_boat,
    });
    if (result.status === "success" && result.data.numOfSeatAvailable > 0) {
      setSection("selectMethod");
    }
  };

  const onSelectMethod = (value) => {
    setMethod(value);
    setSection("passport");
  };

  const onUploadImage = async (imageData) => {
    onSetIsLoading(true);
    await onOcrPassport({
      replyToken,
      file: imageData,
    }).then((res) => {
      const {
        status,
        message,
        replyToken,
        document_type,
        passport_number,
        id_card,
        first_name,
        last_name,
        date_of_birth, // dd/mm/yyyy
        country,
        nationality,
        date_of_expiry,
      } = res;

      let personal_id = null;
      if (document_type === "thai_id") {
        personal_id = id_card;
      } else if (document_type === "passport") {
        personal_id = passport_number;
      }

      const rev_date_of_birth =
        formatDateTime_ddmmyyyy_to_yyyymmdd_v1(date_of_birth);

      const id_country = countryOption.find(
        (el) => el.alpha3.toLowerCase() === (country || "-").toLowerCase()
      )?.value;

      const id_nationality = nationalityOption.find(
        (el) =>
          el.label_en.toLowerCase() === (nationality || "-").toLowerCase() ||
          el.label_th.toLowerCase() === (nationality || "-").toLowerCase()
      )?.value;
      const ocr = {
        firstname: first_name,
        lastname: last_name,
        gender: null,
        date_of_birth: rev_date_of_birth,
        country: country,
        nationality: nationality,
        id_country,
        id_nationality,
        id_passport_no: personal_id,
      };

      reset(ocr);
      setMethod("form");
      setIsUseOcr(true);
      onSetIsLoading(false);
    });
  };

  const onSign = () => {
    setIsSign(true);
  };

  const onSubmit = async (data) => {
    if (!isSign) return;

    onSetIsLoading(true);
    const signBase64 = await getBase64();
    const payload = {
      id_tour_and_date: selectedBoat?.id_tour_and_date,
      id_boat: selectedBoat?.id_boat,
      passenger_data: {
        firstname: `${data.firstname}`.trim(),
        lastname: `${data.lastname}`.trim(),
        id_gender: data.id_gender,
        date_of_birth: data.date_of_birth,
        id_country: data.id_country,
        id_nationality: data.id_nationality,
        id_passport_no: data.id_passport_no,
        age: data.age,
        na: data.na,
        checkin_no: `${data.checkin_no}`.trim(),
      },
      signature_data: {
        signature_base64: signBase64,
        device_ipv4: ipv4,
        device_ipv6: ipv6,
        device_type: deviceType,
        sign_timestamp: formatTimeToDateTimeV1(new Date().getTime()),
        sign_timestamp_number: new Date().getTime(),
        acknowledge: data.acknowledge,
      },
      transaction_id: transactionId,
    };
    const operationType =
      section === "select-port-boat" ? "select-port-and-boat" : "scan-qr-code";
    const res = await submitPassenger(payload, token, {
      operationType,
    });
    if (res.status === "success") {
      reset({});
      setMethod(null);
      if (section === "select-port-boat") {
        setSection("finish-for-select-port-boat");
      } else {
        setSection("finish");
      }
    } else {
      setValue("acknowledge", false);
      setIsSign(false);
      alert(msg.alert, msg[res.keyMsg]);
    }
    onSetIsLoading(false);
  };

  const onSetTourAndBoatDetail = async ({ id_tour, id_boat }) => {
    const res = await readTourAndBoatDetail({ id_tour, id_boat });
    setTourAndBoatDetail(res.data.result);
  };

  const onCancel = () => {
    onSetReplyToken();
    reset({});
    setMethod(null);
    setSection("selectMethod");
    setIsUseOcr(false);
    // window.location.reload();
  };

  const onSetReplyToken = () => {
    const temp = onGenerateReplyToken();
    setReplyToken((prev) => temp);
  };

  const loadPortData = async (id_project) => {
    if (localStorage.getItem("login-token")) {
      const result = await readPortAndTourByIdProject({ id_project });
      setFetchPortData(result.data);
      return result;
    } else {
      window.location.replace("/");
    }
  };

  const onSelectPort = ({ id_port }) => {
    const selectedPortData = dataPortList.find((el) => el.id_port === id_port);
    setSelectedPort(selectedPortData);
    setSelectedBoat(null);
  };

  const onSelectBoat = ({ id_tour_and_date, id_boat }) => {
    const boatData = selectedPort.activeBoatList.find(
      (el) =>
        el.id_tour_and_date === id_tour_and_date && el.boat.id_boat === id_boat
    );

    setSelectedBoat({
      id_tour_and_date,
      id_boat,
      tour_name: boatData?.tour?.tour_name || "",
      boat_name: boatData?.boat?.boat_name || "",
    });
  };

  const onFilterPort = (e) => {
    const keyword = e.target.value.toLowerCase();
    const filteredPorts = dataPortList.filter((port) =>
      port.port.toLowerCase().includes(keyword)
    );
    setFilteredPortData(filteredPorts);
  };

  const gotoPortPage = () => {
    setSelectedBoat(null);
    setSelectedPort(null);
    setSection("select-port-boat");
    onSetTransactionIdAndTimestamp();
    handleClear();
    setFilteredPortData([]);
  };

  const gotoBoatPage = () => {
    setSelectedBoat(null);
    setSection("select-port-boat");
    onSetTransactionIdAndTimestamp();
    handleClear();
  };

  const onBack = () => {
    if (!(Boolean(selectedPort) === false || Boolean(selectedBoat) === true)) {
      gotoPortPage();
    }
    if (!(Boolean(selectedPort) === false || Boolean(selectedBoat) === false)) {
      gotoBoatPage();
    }
  };

  const onClickNextForSelectPortBoat = async () => {
    setSection("select-port-boat");
    onSetTransactionIdAndTimestamp();
  };

  const onInitForAuth = async (id_project, setNotFound) => {
    await onSetupLang();
    await checkCompanyExist({ id_project }).then((res) => {
      if (res.status !== "success") {
        setNotFound(true);
      }
    });
  };

  const shareContextValue = useMemo(
    () => ({
      msg,
      section,
      method,
      hookForm,
      countryOption,
      nationalityOption,
      isLoading,
      dateTime,
      captureImageRef,
      tourAndBoatDetail,
      transactionId,
      ipv4,
      ipv6,
      isSign,
      genderOption,
      deviceType,
      replyToken,
      signPadRef,
      isUseOcr,
      fetchPortData,

      selectedPort,
      selectedBoat,
      filteredPortData,
      dataPortList,

      onSelectMethod,
      onUploadImage,
      onSubmit,
      onAfterScanQrCode,
      onSetCountryOption,
      onSetNationalityOption,
      onSetIsLoading,
      onSetTourAndBoatDetail,
      onSetTransactionIdAndTimestamp,
      onInitMain,
      onInitMainForSelectPortBoat,
      onSign,
      onCancel,
      onSetToken,
      onSetReplyToken,
      handleClear,
      setFetchPortData,

      loadPortData,
      onBack,
      onFilterPort,
      onSelectPort,
      onSelectBoat,

      gotoPortPage,
      gotoBoatPage,

      onClickNextForSelectPortBoat,
      onInitForAuth,
    }),
    [
      msg,
      section,
      method,
      hookForm,
      countryOption,
      nationalityOption,
      isLoading,
      dateTime,
      captureImageRef,
      tourAndBoatDetail,
      transactionId,
      ipv4,
      ipv6,
      isSign,
      genderOption,
      deviceType,
      replyToken,
      isUseOcr,
      fetchPortData,
      selectedPort,
      selectedBoat,
      filteredPortData,
      dataPortList,
    ]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      const newDate = new Date();
      const display = formatDateTime({ datetime: newDate, msg });
      setDateTime(display);
      autoFilterBoatInPortByActiveBoatList();
    }, 1000);
    return () => clearInterval(timer);
  }, [msg, fetchPortData]);

  useEffect(() => {
    if (isSign === false) {
      setValue("acknowledge", false);
    }
  }, [isSign]);

  return (
    <ShareContext.Provider value={shareContextValue}>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/:id_project" element={<Auth />} />
        <Route path="/:id_project/main" element={<Main />} />
        {process.env.REACT_APP_ENV === "development" && (
          <Route path="/dev" element={<Dev />} />
        )}

        {/* จับทุก path ที่ไม่ตรงข้างบน แล้ว redirect ไป "/" */}
        <Route path="*" element={<ExternalRedirect url="https://pkid.io" />} />
      </Routes>
      {AlertModal}
    </ShareContext.Provider>
  );
}

const Auth = () => {
  const { msg, onInitForAuth } = useContext(ShareContext);
  const loc = useLocation();
  const searchParams = new URLSearchParams(loc.search);
  const urlParams = loc.pathname.split("/").filter(Boolean);
  const id_project = urlParams[0] || searchParams.get("id_project");

  const [password, setPassword] = useState("");
  const [notFound, setNotFound] = useState(false);
  const [isLoginFailed, setIsLoginFailed] = useState(false);

  const onLogin = async (e) => {
    e.preventDefault();
    const result = await login({ id_project, password });
    if (result.status === "success") {
      const { token } = result.data;
      localStorage.setItem("login-token", token);
      window.location.replace(`/${id_project}/main`);
    } else {
      setIsLoginFailed(true);
    }
  };

  useEffect(() => {
    localStorage.clear();
    if (id_project) {
      onInitForAuth(id_project, setNotFound);
    }
  }, []);

  if (notFound) {
    localStorage.clear();
    window.location.href = "https://pkid.io";
  }

  return (
    <main className="page-auth">
      <header className="header">
        <div>
          <Logo />
        </div>
        <br />
      </header>
      <form className="container-auth">
        <label>{msg?.company_password}</label>
        <CustomInputText
          placeholder={msg?.please_enter_your_company_password}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {isLoginFailed && (
          <div className="message-login-failed">
            {msg?.login_failed_please_contact_admin}
          </div>
        )}
        <button className="button-submit" onClick={onLogin}>
          {msg?.login}
        </button>
      </form>
      <footer className="footer">{msg?.copyright}</footer>
    </main>
  );
};

const Main = () => {
  const {
    msg,
    section,
    method,
    isLoading,
    dateTime,
    tourAndBoatDetail,
    onInitMain,
    onInitMainForSelectPortBoat,
    isUseOcr,
    fetchPortData,
    selectedPort,
    selectedBoat,
    onBack,
    onFilterPort,
    filteredPortData,
    dataPortList,
    onSelectPort,
    onSelectBoat,
  } = useContext(ShareContext);
  const loc = useLocation();
  const searchParams = new URLSearchParams(loc.search);
  const token = searchParams.get("token"); // มี payload = {tad:id_tour_and_date,b:id_boat}
  const urlParams = loc.pathname.split("/").filter(Boolean);
  const id_project = urlParams[0] || searchParams.get("id_project");
  const [notFound, setNotFound] = useState(false);

  const company_name = fetchPortData?.company_name;

  useEffect(() => {
    if (id_project) {
      onInitMainForSelectPortBoat(id_project, setNotFound);
    } else if (token) {
      onInitMain(token, setNotFound);
    } else {
      setNotFound(true);
    }
  }, []);

  if (notFound) {
    localStorage.clear();
    window.location.href = "https://pkid.io";
  }

  if (isLoading || msg === null) {
    return <Loading />;
  }

  if (id_project) {
    return (
      <>
        {(selectedPort || selectedBoat) && (
          <div className="button-back" onClick={() => onBack()}>
            <Svg
              iconName="IconBack"
              style={{ height: "3rem", width: "3rem" }}
            />
          </div>
        )}
        <main>
          <header className="header">
            <div>
              <Logo />
            </div>
            {company_name && (
              <div className="header-text">
                <label>{`${msg.company_name}:`}</label>
                <label>{company_name?.en || ""}</label>
              </div>
            )}
            {selectedPort && (
              <div className="header-text">
                <label>{`${msg.port_name}:`}</label>
                <label>{selectedPort.port || ""}</label>
              </div>
            )}
            {selectedBoat && (
              <div className="header-text">
                <label>{`${msg.tour_name}:`}</label>
                <label>{selectedBoat.tour_name || ""}</label>
              </div>
            )}
            {selectedBoat && (
              <div className="header-text">
                <label>{`${msg.boat_name}:`}</label>
                <label>{selectedBoat.boat_name || ""}</label>
              </div>
            )}
            <br />
            <div>
              <div className="datetime_display">{dateTime}</div>
            </div>
          </header>

          {section === "select-port-boat" && dataPortList.length > 0 ? (
            <>
              <br />
              {!(Boolean(selectedPort?.id_port) === true) && (
                <section className="section-select-port">
                  <div className="section-select-port-title">
                    {msg.select_a_port}
                  </div>
                  <div className="section-select-port-search">
                    <CustomInputText
                      placeholder="Search"
                      onChange={onFilterPort}
                    />
                  </div>
                  <div className="container-port-list">
                    {(filteredPortData.length > 0
                      ? filteredPortData
                      : dataPortList
                    )
                      .filter((el) => el.numOfBoat > 0)
                      .map((el) => (
                        <div
                          className="item-port-list"
                          key={el.id_port}
                          onClick={() => onSelectPort({ id_port: el.id_port })}
                        >
                          <div className="icon-boat">
                            <Svg
                              iconName={"IconBoat"}
                              style={{ height: "4rem" }}
                            />
                          </div>
                          <div>
                            <div className="port-name">{el.port}</div>
                            <div className="num-of-boat">{`${el.numOfBoat} ${msg.boat}`}</div>
                          </div>
                        </div>
                      ))}
                  </div>
                </section>
              )}
              {!(
                Boolean(selectedBoat) === true ||
                Boolean(selectedPort?.id_port) === false
              ) && (
                <section className="section-select-boat">
                  <div className="section-select-boat-header">
                    <span>{msg.boat_list}</span>
                    <span>
                      {selectedPort?.numOfBoat || 0} {msg.boat}
                    </span>
                  </div>
                  <div className="container-boat-list">
                    {(selectedPort?.activeBoatList || []).map((el, index) => (
                      <div
                        className="item-boat"
                        key={index}
                        onClick={() =>
                          onSelectBoat({
                            id_tour_and_date: el.id_tour_and_date,
                            id_boat: el.boat.id_boat,
                          })
                        }
                      >
                        <div className="block-boat-image">
                          <div className="boat-image">
                            {el.boat.image ? (
                              <img
                                src={`https://storage.googleapis.com/agent-marine-2025/${el.boat.image_filepath}`}
                                alt={el.boat.boat_name}
                              />
                            ) : (
                              <Svg
                                iconName="EmptyImage"
                                style={{ height: "3rem" }}
                              />
                            )}
                          </div>
                          <div className="badge-boat-type">
                            <div>{el.boat.boat_type}</div>
                          </div>
                        </div>
                        <div className="block-boat-and-tour-detail">
                          <div>
                            <span>{el.boat.boat_name}</span>
                          </div>
                          <div>
                            <div>
                              <span>{`${msg.tour_name}:`}</span>
                              <span>{el.tour.tour_name}</span>
                            </div>
                            <div>
                              <span>{`${msg.tour_type}:`}</span>
                              <span>{el.tour.tour_type}</span>
                            </div>
                            <div>
                              <span>{`${msg.destination}:`}</span>
                              <span>
                                {el.destination
                                  .map((el) => el.destination)
                                  .join(", ")}
                              </span>
                            </div>
                            <div>
                              <span>{`${msg.team_name}:`}</span>
                              <span>{el.team.team_name}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              )}
              {!(Boolean(selectedBoat) === false) && (
                <section>
                  <FormPassenger hiddenButtonCancel={true} />
                </section>
              )}
            </>
          ) : (
            section !== "finish-for-select-port-boat" && (
              <div
                style={{
                  fontSize: "1rem",
                  color: "var(--primary)",
                  textAlign: "center",
                  margin: "auto",
                }}
              >
                {msg.there_is_tour_available_at_the_moment}
              </div>
            )
          )}
          {section === "finish-for-select-port-boat" && (
            <MessageSubmitSuccessForSelectPortBoat />
          )}

          <footer className="footer">{dictionary.copyright}</footer>
        </main>
      </>
    );
  }

  return (
    <main>
      <header className="header">
        <div>
          <Logo />
        </div>
        <div className="header-text">
          <label>{msg.tour_name}:</label>
          <label>{tourAndBoatDetail.tour_detail.tour_name}</label>
        </div>
        <div className="header-text">
          <label>{msg.boat_name}:</label>
          <label>{tourAndBoatDetail.boat_detail.boat_name}</label>
        </div>
        <br />
        <div>
          <div className="datetime_display">{dateTime}</div>
        </div>
        {isUseOcr && section === "passport" && (
          <>
            <br />
            <div>
              <div className="please_verify_the_information_before_submitting">
                {msg.please_verify_the_information_before_submitting}
              </div>
            </div>
          </>
        )}
      </header>
      <ContentCover>
        {section === "afterScanQrCode" && <ContainerBoatList boatList={[]} />}
        {section === "selectMethod" && <SelectMethod />}
        {section === "passport" && method === "photo" && <UploadPhoto />}
        {section === "passport" && method === "form" && <FormPassenger />}
        {section === "finish" && <MessageSubmitSuccess />}
      </ContentCover>
      <footer className="footer">{dictionary.copyright}</footer>
    </main>
  );
};

const MessageSubmitSuccess = () => {
  const { msg } = useContext(ShareContext);
  const onClickNext = () => window.location.reload();
  return (
    <div className="component-data_saved_successfully">
      <label>{msg.data_saved_successfully}</label>
      <button onClick={onClickNext}>{msg.next}</button>
    </div>
  );
};

const MessageSubmitSuccessForSelectPortBoat = () => {
  const { msg, gotoBoatPage, gotoPortPage, onClickNextForSelectPortBoat } =
    useContext(ShareContext);
  return (
    <div className="component-data_saved_successfully">
      <label>{msg.data_saved_successfully}</label>
      <button onClick={onClickNextForSelectPortBoat}>
        {msg.next_passenger}
      </button>
      <div
        style={{
          fontSize: "1.2rem",
          color: "var(--secondary)",
          textDecoration: "underline",
          textUnderlineOffset: "0.2rem",
          cursor: "pointer",
        }}
        onClick={gotoPortPage}
      >
        {msg.select_a_port}
      </div>
      <div
        style={{
          fontSize: "1.2rem",
          color: "var(--secondary)",
          textDecoration: "underline",
          textUnderlineOffset: "0.2rem",
          cursor: "pointer",
        }}
        onClick={gotoBoatPage}
      >
        {msg.select_a_boat}
      </div>
    </div>
  );
};

const ContainerBoatList = ({ boatList = [] }) => {
  const { msg } = useContext(ShareContext);
  return (
    <>
      {boatList.length > 0 && <div>{msg.there_is_data}</div>}
      {boatList.length === 0 && (
        <div className="no-boat">
          <div>
            <Svg iconName="IconEmptyData" />
          </div>
          <div>
            <p>{msg.no_boat_available_on_this_date_please_try_another_date}</p>
          </div>
        </div>
      )}
    </>
  );
};

const SelectMethod = () => {
  const { msg, onSelectMethod, hookForm } = useContext(ShareContext);
  const { reset } = hookForm;
  return (
    <div className="selectMethod">
      <ButtonMethod
        icon={<Svg className="icon" iconName="IconA" />}
        text={msg.scan_your_passport}
        onClick={() => onSelectMethod("photo")}
      />
      <ButtonMethod
        icon={<Svg className="icon" iconName="IconB" />}
        text={msg.enter_manually}
        onClick={() => {
          reset({});
          onSelectMethod("form");
        }}
      />
    </div>
  );
};

const ButtonMethod = ({ icon, text, onClick }) => {
  return (
    <button className="buttonMethod" onClick={onClick}>
      <div>{icon}</div>
      <label>{text}</label>
    </button>
  );
};

const UploadPhoto = () => {
  const { msg, onUploadImage } = useContext(ShareContext);
  const [base64, setBase64] = useState(null);
  const fileRef = useRef();

  const onGetBase64From = (file, callback) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result);
    reader.onerror = () => callback(null);
    reader.readAsDataURL(file);
  };

  const onSubmitImage = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    onUploadImage(file);
    return;

    onGetBase64From(file, (result) => {
      if (result) {
        setBase64(result);
        onUploadImage(result);
      } else {
        console.error("Failed to convert to base64");
      }
    });
  };

  return (
    <>
      <div className="container-uploadPhoto">
        <div className="uploadPhoto" onClick={() => fileRef.current?.click()}>
          <Svg iconName="IconUploadImage" className="icon" />
          <label>{msg.upload_passport_photo}</label>
          <label>
            {`${msg.please_upload_clear_image_of_your_passport}. ${msg.accepted_formats}: ${msg.jpg}, ${msg.png}`}
          </label>
        </div>
      </div>
      <input
        hidden
        type="file"
        ref={fileRef}
        accept="image/png, image/jpeg"
        onChange={onSubmitImage}
      />
    </>
  );
};

const FormPassenger = ({ hiddenButtonCancel = false }) => {
  const {
    msg,
    hookForm,
    onSubmit,
    countryOption,
    nationalityOption,
    captureImageRef,
    transactionId,
    dateTime,
    onSign,
    isSign,
    genderOption,
    deviceType,
    onCancel,
    signPadRef,
    handleClear,
  } = useContext(ShareContext);
  const {
    register,
    getValues,
    formState: { errors },
    setValue,
    watch,
    control,
  } = hookForm;

  const firstname = watch("firstname");
  const lastname = watch("lastname");
  const id_gender = watch("id_gender");
  const date_of_birth = watch("date_of_birth");
  const na = watch("na");
  const age = watch("age");
  const id_country = watch("id_country");
  const id_nationality = watch("id_nationality");
  const id_passport_no = watch("id_passport_no");
  const checkin_no = watch("checkin_no");
  const acknowledge = watch("acknowledge");

  const [localeIsEnOrTh, setLocaleIsEnOrTh] = useState(null);

  const isEnabledSignaturePad =
    firstname &&
    lastname &&
    id_gender &&
    (date_of_birth || na) &&
    +age >= 0 &&
    id_country &&
    id_nationality &&
    id_passport_no &&
    checkin_no;

  const onClickNAIdpassportNo = (event) => {
    const checked = event.target.checked;
    if (checked) {
      setValue("id_passport_no", "N/A");
    } else {
      setValue("id_passport_no", "");
    }
  };

  useEffect(() => {
    if (na) {
      setValue("date_of_birth", null);
    }
  }, [na]);

  useEffect(() => {
    if (date_of_birth) {
      const age = calculateAge(date_of_birth); // YYYY-MM-DD
      setValue("age", age);
    }
  }, [date_of_birth]);

  useEffect(() => {
    if (Boolean(isEnabledSignaturePad) === false) {
      setValue("acknowledge", false);
    }
  }, [isEnabledSignaturePad]);

  useEffect(() => {
    let fullname = `${firstname || ""}${lastname || ""}`;
    fullname = fullname.replaceAll(" ", "").replaceAll("-", "");
    const isEmpty = fullname === "";
    if (isEmpty) {
      setLocaleIsEnOrTh(true);
    } else {
      const temp = checkFullnameIsValid(fullname);
      setLocaleIsEnOrTh(temp);
    }
  }, [firstname, lastname]);

  return (
    <div className="container-form-passport">
      <div className="form-passport">
        <div className="_input_text_select">
          <label>{msg.firstname}*</label>
          <Controller
            control={control}
            name="firstname"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomInputText
                placeholder={msg.firstname}
                value={field.value || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // อนุญาตเฉพาะภาษาอังกฤษ, ภาษาไทย, ตัวเลข 0-9, ขีด (-) และช่องว่าง
                  const regex = /^[a-zA-Z0-9ก-๙\s-]*$/;
                  // ไม่ให้เริ่มต้นด้วยช่องว่างหรือขีด
                  const startsWithInvalid = /^[\s-]/.test(value);
                  // ไม่ให้มีช่องว่างติดกัน หรือขีดติดกัน
                  const hasConsecutive = /(\s{2,}|-{2,})/.test(value);

                  if (
                    regex.test(value) &&
                    !startsWithInvalid &&
                    !hasConsecutive
                  ) {
                    field.onChange(e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="_input_text_select">
          <label>{msg.lastname}*</label>
          <Controller
            control={control}
            name="lastname"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomInputText
                placeholder={msg.lastname}
                value={field.value || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // อนุญาตเฉพาะภาษาอังกฤษ, ภาษาไทย, ตัวเลข 0-9, ขีด (-) และช่องว่าง
                  const regex = /^[a-zA-Z0-9ก-๙\s-]*$/;
                  // ไม่ให้เริ่มต้นด้วยช่องว่างหรือขีด
                  const startsWithInvalid = /^[\s-]/.test(value);
                  // ไม่ให้มีช่องว่างติดกัน หรือขีดติดกัน
                  const hasConsecutive = /(\s{2,}|-{2,})/.test(value);

                  if (
                    regex.test(value) &&
                    !startsWithInvalid &&
                    !hasConsecutive
                  ) {
                    field.onChange(e);
                  }
                }}
              />
            )}
          />
        </div>
        {localeIsEnOrTh === false && (
          <div className="container-warning-form-passport-1 span-2">
            <div className="warning-text">{msg["form-warning-2"]}</div>
          </div>
        )}
        <div className="_input_text_select span-2" style={{ gap: 4 }}>
          <label>{msg.gender}*</label>
          <div className="radio-group">
            <div className="_input_radio">
              <input
                type="radio"
                {...register("id_gender", { required: true })}
                className={errors["id_gender"] ? "_data_invalid" : ""}
                value={
                  genderOption.find((el) => el.label.toLowerCase() === "male")
                    .value
                }
              />
              <label style={{ fontSize: "0.8rem" }}>{msg.male}</label>
            </div>
            <div className="_input_radio">
              <input
                type="radio"
                {...register("id_gender", { required: true })}
                className={errors["id_gender"] ? "_data_invalid" : ""}
                value={
                  genderOption.find((el) => el.label.toLowerCase() === "female")
                    .value
                }
              />
              <label style={{ fontSize: "0.8rem" }}>{msg.female}</label>
            </div>
          </div>
        </div>
        <div className="_input_text_select">
          <label>{msg.date_of_birth}*</label>
          <Controller
            name="date_of_birth"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              <div>
                <CustomDatePicker
                  className={fieldState.error ? "_data_invalid" : ""}
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(date) => field.onChange(date)}
                  maxDate={dayjs().format("YYYY-MM-DD")}
                  placeholder={msg.date_of_birth}
                />
              </div>
            )}
          />
        </div>
        <div className="_input_text_select">
          <label>{msg.age}*</label>
          <Controller
            control={control}
            name="age"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomInputText
                placeholder={msg.age}
                value={field.value}
                onChange={field.onChange}
                disabled
              />
            )}
          />
        </div>
        <div className="_input_text_select">
          <label>{msg.country}*</label>
          <Controller
            control={control}
            name="id_country"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomSelect
                value={field.value}
                options={countryOption}
                placeholder={msg.country}
                onChange={field.onChange}
              />
            )}
          />
        </div>
        <div className="_input_text_select">
          <label>{msg.nationality}*</label>
          <Controller
            control={control}
            name="id_nationality"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomSelect
                value={field.value}
                options={nationalityOption}
                placeholder={msg.nationality}
                onChange={field.onChange}
              />
            )}
          />
        </div>
        <div className="span-2 _input_text_select">
          <label>
            {`${msg.thai_id}/${msg.passport_no}`.replace("ประจำตัว", "")}*
          </label>
          <Controller
            control={control}
            name="id_passport_no"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomInputText
                placeholder={`${msg.thai_id}/${msg.passport_no}`}
                value={field.value || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // อนุญาตเฉพาะภาษาอังกฤษและตัวเลข
                  const regex = /^[a-zA-Z0-9]*$/;
                  if (regex.test(value)) {
                    field.onChange(e);
                  }
                }}
                disabled={id_passport_no === "N/A"}
              />
            )}
          />
          <div className="extra_checkbox">
            <input
              onChange={onClickNAIdpassportNo}
              type="checkbox"
              checked={id_passport_no === "N/A"}
            />
            <label>{`${msg.na}`.replace("ไม่มีข้อมูล", "ไม่ระบุ")}</label>
          </div>
        </div>
        <div className="span-2 _input_text_select">
          <label>{msg.checkin_no}*</label>
          <Controller
            control={control}
            name="checkin_no"
            rules={{ required: true }}
            render={({ field }) => (
              <CustomInputText
                placeholder={msg.checkin_no}
                value={field.value || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  // อนุญาตเฉพาะภาษาอังกฤษ ภาษาไทย ตัวเลข และขีด (-)
                  const regex = /^[a-zA-Z0-9ก-๙-]*$/;
                  if (regex.test(value)) {
                    field.onChange(e);
                  }
                }}
              />
            )}
          />
        </div>
        <div className="span-2 _input_text_select">
          <label>{msg["customer/guardian_signature"]}*</label>
          <div
            style={{
              opacity: !isEnabledSignaturePad ? 0.3 : 1,
            }}
          >
            <CaptureWrapper captureRef={captureImageRef}>
              <div className="container-signature">
                <SignaturePad
                  setBase64={onSign}
                  isDisabled={!isEnabledSignaturePad}
                  ref={signPadRef}
                  passengerFullname={`${firstname} ${lastname}`}
                />
                <label className="transaction_id">{transactionId || ""}</label>
                <label className="device">{deviceType || ""}</label>
                <label className="timestamp">{dateTime || ""}</label>
              </div>
            </CaptureWrapper>
            {isSign && isEnabledSignaturePad && (
              <div
                style={{
                  marginBottom: 4,
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <button
                  onClick={handleClear}
                  className="button-clear-signature"
                >
                  {msg.remove}
                </button>
              </div>
            )}
            <div className="terms-and-policy">
              <p>
                {msg.by_submitting_up_you_agree_to_our}{" "}
                <Link
                  to="https://agentmarine.co/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {msg.terms}
                </Link>
                {` ${msg.and} `}
                <Link
                  to="https://agentmarine.co/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {msg.privacy_policy}
                </Link>
                .
              </p>
            </div>
            <div className="container-warning-form-passport-2 span-2">
              <div className="warning-text">{msg["form-warning-1"]}</div>
            </div>
            <div className="acknowledge">
              <input
                disabled={!isSign}
                className={errors["acknowledge"] ? "_data_invalid" : ""}
                type="checkbox"
                {...register("acknowledge", { required: true })}
              />
              <label>{msg.acknowledge}</label>
            </div>
          </div>
        </div>
        {hiddenButtonCancel ? (
          <div style={{ gridColumn: "span 2" }}>
            <button
              onClick={hookForm.handleSubmit(onSubmit)}
              disabled={!acknowledge}
              className={`button-fill ${
                !acknowledge ? "button-fill-disabled" : ""
              }`}
            >
              {msg.submit}
            </button>
          </div>
        ) : (
          <>
            <div>
              <button onClick={onCancel} className="button-outline">
                {msg.cancel}
              </button>
            </div>
            <div>
              <button
                onClick={hookForm.handleSubmit(onSubmit)}
                disabled={!acknowledge}
                className={`button-fill ${
                  !acknowledge ? "button-fill-disabled" : ""
                }`}
              >
                {msg.submit}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
